import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonsModule } from '@hiptraveler/ui/buttons';
import { DialogCloseButtonModule } from '@hiptraveler/ui/dialog-close-button';

import { NewActivityDialogComponent } from './new-activity-dialog.component';

const MODULES = [
  CommonModule,
  MatFormFieldModule,
  MatInputModule,
  TranslateModule
];

const LIBRARIES = [
  ButtonsModule,
  DialogCloseButtonModule
];

const COMPONENTS = [
  NewActivityDialogComponent
];

@NgModule({
  imports: [
    MODULES,
    LIBRARIES
  ],
  declarations: [
    COMPONENTS
  ],
})
export class NewActivityDialogModule { }
